module.exports = __webpack_public_path__ + "img/empreendimento-logo-31.d61301c9.png";